/* eslint-disable */
import dagre from 'dagre';
import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';
import { DESIGNER_SETTINGS } from '../../../../../app/constants/designer_settings';
import { COMPONENT_TYPE } from '../../../../../app/constants/component_type';
import { updatePackage } from '../../../../../app/package-designer/store/package.actions';
import { modifyComponentBeforeSave } from '../../../../../app/package-designer/helpers/package.helpers';

function downloadObjectAsJson(exportObj, exportName) {
  const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportObj, null, 4));
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', exportName + '.json');
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerPackage', [
    '$rootScope',
    '$timeout',
    'DesignerBase',
    'DesignerComponent',
    'DesignerFileStorageSourceComponent',
    'DesignerAmazonRedshiftSourceComponent',
    'DesignerDatabaseSourceComponent',
    'DesignerGoogleBigQuerySourceComponent',
    'DesignerGoogleAnalyticsSourceComponent',
    'DesignerGoogleAnalytics4SourceComponent',
    'DesignerGoogleAdwordsSourceComponent',
    'DesignerGoogleAdsDestinationComponent',
    'DesignerSalesforceSourceComponent',
    'DesignerGoogleSpannerSourceComponent',
    'DesignerFacebookAdsInsightsSourceComponent',
    'DesignerBingSourceComponent',
    'DesignerRestApiSourceComponent',
    'DesignerFileStorageDestinationComponent',
    'DesignerDatabaseDestinationComponent',
    'DesignerGoogleSpannerDestinationComponent',
    'DesignerAmazonRedshiftDestinationComponent',
    'DesignerGoogleBigqueryDestinationComponent',
    'DesignerMongoDBDestinationComponent',
    'DesignerSnowflakeDestinationComponent',
    'DesignerMongoDBSourceComponent',
    'DesignerNetsuiteSourceComponent',
    'DesignerNetsuiteDestinationComponent',
    'DesignerTiktokAdsDestinationComponent',
    'DesignerSelectComponent',
    'DesignerSortComponent',
    'DesignerLimitComponent',
    'DesignerSampleComponent',
    'DesignerUnionComponent',
    'DesignerRankComponent',
    'DesignerAggregateComponent',
    'DesignerJoinComponent',
    'DesignerCrossJoinComponent',
    'DesignerFilterComponent',
    'DesignerAssertComponent',
    'DesignerCloneComponent',
    'DesignerWindowComponent',
    'DesignerCubeComponent',
    'DesignerSalesforceDestinationComponent',
    'DesignerFacebookDestinationComponent',
    'DesignerSalesforceSoapDestinationComponent',
    'DesignerRunPackageComponent',
    'DesignerExecuteSqlComponent',
    'DesignerEdge',
    'DesignerNote',
    'Package',
    'modalService',
    '$stateParams',
    '$state',
    'notify',
    '$translate',
    'ngrxStoreService',
    function (
      $rootScope,
      $timeout,
      DesignerBase,
      DesignerComponent,
      DesignerFileStorageSourceComponent,
      DesignerAmazonRedshiftSourceComponent,
      DesignerDatabaseSourceComponent,
      DesignerGoogleBigQuerySourceComponent,
      DesignerGoogleAnalyticsSourceComponent,
      DesignerGoogleAnalytics4SourceComponent,
      DesignerGoogleAdwordsSourceComponent,
      DesignerGoogleAdsDestinationComponent,
      DesignerSalesforceSourceComponent,
      DesignerGoogleSpannerSourceComponent,
      DesignerFacebookAdsInsightsSourceComponent,
      DesignerBingSourceComponent,
      DesignerRestApiSourceComponent,
      DesignerFileStorageDestinationComponent,
      DesignerDatabaseDestinationComponent,
      DesignerGoogleSpannerDestinationComponent,
      DesignerAmazonRedshiftDestinationComponent,
      DesignerGoogleBigqueryDestinationComponent,
      DesignerMongoDBDestinationComponent,
      DesignerSnowflakeDestinationComponent,
      DesignerMongoDBSourceComponent,
      DesignerNetsuiteSourceComponent,
      DesignerNetsuiteDestinationComponent,
      DesignerTiktokAdsDestinationComponent,
      DesignerSelectComponent,
      DesignerSortComponent,
      DesignerLimitComponent,
      DesignerSampleComponent,
      DesignerUnionComponent,
      DesignerRankComponent,
      DesignerAggregateComponent,
      DesignerJoinComponent,
      DesignerCrossJoinComponent,
      DesignerFilterComponent,
      DesignerAssertComponent,
      DesignerCloneComponent,
      DesignerWindowComponent,
      DesignerCubeComponent,
      DesignerSalesforceDestinationComponent,
      DesignerFacebookDestinationComponent,
      DesignerSalesforceSoapDestinationComponent,
      DesignerRunPackageComponent,
      DesignerExecuteSqlComponent,
      DesignerEdge,
      DesignerNote,
      Package,
      modalService,
      $stateParams,
      $state,
      notify,
      $translate,
      ngrxStoreService,
    ) {
      function DesignerPackage(data, designer) {
        this._lastSavedPackageData;
        this._data = data;
        this._componentsCounter = 0;
        this._edgesCounter = 0;

        this.designer = designer;

        this.componentWidth = DESIGNER_SETTINGS.COMPONENT_WIDTH;
        this.componentHeight = DESIGNER_SETTINGS.COMPONENT_HEIGHT;
        this.noteWidth = DESIGNER_SETTINGS.NOTE_WIDTH;
        this.noteHeight = DESIGNER_SETTINGS.NOTE_HEIGHT;
        this.padding = DESIGNER_SETTINGS.PADDING;

        this.width = 0;
        this.height = 0;

        this.components = [];
        this.edges = [];
        this.notes = [];

        this.name = null;
        this.description = null;
        this.json = null;
        this.variables = null;
        this.flow_type = null;
        this.flow_version = null;
        this.owner_id = null;
        this.created_at = null;
        this.updated_at = null;
        this.status = null;
        this.valid = false;
        this.initiated = false;
        this.dataChanged = false;
        this.isFirstLoad = true;
        this.package_version = null;
        this.version_description = null;

        this.setData(data, true);
        this.initEvents();
      }

      DesignerPackage.prototype = new DesignerBase();

      DesignerPackage.prototype.setData = function (data) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.variables = data.variables;
        this.flow_type = data.flow_type || DESIGNER_SETTINGS.PACKAGE_DEFAULT_FLOW_TYPE;
        this.flow_version = data.flow_version || DESIGNER_SETTINGS.FLOW_VERSION;
        this.owner_id = data.owner_id;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
        this.status = data.status;
        this.package_version = data.package_version;

        if (data.data_flow_json) {
          this.json = JSON.parse(data.data_flow_json);
        } else {
          this.json = {
            components: [],
            edges: [],
          };
        }

        const _this = this;

        this.components = [];
        this.edges = [];
        this.notes = [];

        _.each(this.json.components, function (component) {
          const type = Object.keys(component)[0];
          const newComponent = _this.createComponentByType(type, component);
          if (type !== COMPONENT_TYPE.STICKY_NOTE_COMPONENT) {
            _this.components.push(newComponent);
          } else {
            _this.notes.push(newComponent);
          }
        });

        _.each(this.json.edges, function (edge) {
          _this.edges.push(new DesignerEdge(edge, _this));
        });

        if (!$rootScope._lastSavedPackageData) {
          $rootScope._lastSavedPackageData = this.getData();
        }

        this._lastSavedPackageData = $rootScope._lastSavedPackageData;

        this.initiated = true;

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_DISABLED, this.components.length === 0);
        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_VERSION, this.package_version === '1.0');
        this.updateDataInStore();
      };

      DesignerPackage.prototype.initEvents = function () {
        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_NAME_SAVE, (event, _package) => {
          this.name = _package.name;
          this.description = _package.description;
          this.update();
          this.designer.history.save('Package name updated');
        });

        $rootScope.$on(DESIGNER_EVENTS.COMPONENT_ADD, (event, component) => {
          this.addComponent(component);
        });

        $rootScope.$on(DESIGNER_EVENTS.COMPONENT_GET_PARENT_SCHEMA, (event, componentId) => {
          const component = this.getComponentById(componentId);

          if (component) {
            const schemas = component.getParentComponentsSchemas();
            $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_RETURN_PARENT_SCHEMA, schemas);
          } else {
            $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_RETURN_PARENT_SCHEMA, []);
          }
        });

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VARIABLES_UPDATE, (event, variables) => {
          this.variables = variables;
          this.designer.history.save('Package variables updated');
          this.updateDataInStore();
        });

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VARIABLES_ADD, (event, variables) => {
          this.variables = {
            ...this.variables,
            ...variables,
          };
          this.designer.history.save('Package variables updated');
          this.updateDataInStore();
        });

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VARIABLES_REMOVE, (event, variableName) => {
          this.variables = {
            ...this.variables,
          };
          delete this.variables[variableName];
          this.designer.history.save('Package variables updated');
          this.updateDataInStore();
        });

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_UPDATE_VERSION, (event, _package) => {
          this.package_version = _package.package_version;
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_VERSION, this.package_version === '1.0');
          this.updateDataInStore();
        });

        $rootScope.$on(DESIGNER_EVENTS.PACKAGE_UPDATE_DATA, (event, _package) => {
          this.setData(_package);
        });
      };

      DesignerPackage.prototype.getData = function () {
        const data = {
          id: this.id,
          name: this.name,
          description: this.description,
          variables: this.variables,
          flow_type: this.flow_type,
          flow_version: this.flow_version || DESIGNER_SETTINGS.FLOW_VERSION,
          owner_id: this.owner_id,
          created_at: this.created_at,
          updated_at: this.updated_at,
          status: this.status,
          package_version: this.package_version,
          version_description: this.version_description,
          data_flow_json: '',
        };

        const json = {
          components: [],
          edges: [],
        };

        _.each(this.components, function (component, index) {
          const componentObject = {};
          componentObject[component.componentType] = modifyComponentBeforeSave(
            component.getData(),
            component.componentType,
          );
          json.components.push(componentObject);
        });

        _.each(this.notes, function (note, index) {
          const componentObject = {};
          componentObject.sticky_note_component = note.getData();
          json.components.push(componentObject);
        });

        _.each(this.edges, function (edge, index) {
          json.edges.push(edge.getData());
        });

        data.data_flow_json = JSON.stringify(json);

        return data;
      };

      DesignerPackage.prototype.setSize = function () {
        let maxWidth = 0;
        let maxHeight = 0;
        let minTop = 0;
        let minLeft = 0;
        const _this = this;

        var offsetLeft = 0;
        var offsetTop = 0;

        const setOffsets = function (component) {
          if (component.x < offsetLeft) offsetLeft = component.x;
          if (component.y < offsetTop) offsetTop = component.y;
        };

        _.each(this.components, setOffsets);
        _.each(this.notes, setOffsets);

        const setMinPosition = function (component) {
          component.setPosition({
            x: component.x + offsetLeft * -1,
            y: component.y + offsetTop * -1 + _this.padding,
          });
        };

        if (
          offsetLeft < 0 ||
          offsetTop < 0 ||
          (offsetTop <= 0 &&
            this.isFirstLoad &&
            (angular.isUndefined(this.flow_version) || this.flow_version.startsWith('1')))
        ) {
          _.each(this.components, setMinPosition);
          _.each(this.notes, setMinPosition);
        }

        _.each(this.components, function (component) {
          const _maxWidth = _this.componentWidth + _this.padding + component.x;
          const _maxHeight = _this.componentHeight + _this.padding + component.y;

          if (maxWidth < _maxWidth) maxWidth = _maxWidth;
          if (maxHeight < _maxHeight) maxHeight = _maxHeight;

          if (minLeft > component.x) minLeft = component.x;
          if (minTop > component.y) minTop = component.y;
        });

        _.each(this.notes, function (note) {
          const _maxWidth = _this.noteWidth + _this.padding + note.x;
          const _maxHeight = _this.noteHeight + _this.padding + note.y;

          if (maxWidth < _maxWidth) maxWidth = _maxWidth;
          if (maxHeight < _maxHeight) maxHeight = _maxHeight;

          if (minLeft > note.x) minLeft = note.x;
          if (minTop > note.y) minTop = note.y;
        });

        if (maxWidth < this.designer.width) {
          maxWidth = this.designer.width;
        }

        if (maxHeight < this.designer.height) {
          maxHeight = this.designer.height;
        }

        // Minimap fix -------------

        const designerRatio = this.designer.width / this.designer.height;
        const packageRatio = maxWidth / maxHeight;

        if (designerRatio > packageRatio) {
          maxWidth = maxHeight * designerRatio;
        } else {
          maxHeight = maxWidth / designerRatio;
        }

        // -------------

        if (minTop < this.padding || minLeft < this.padding) {
          var offsetLeft = minLeft - this.padding;
          var offsetTop = minTop - this.padding;
        }

        this.width = maxWidth !== Infinity && !isNaN(maxWidth) ? maxWidth : 0;
        this.height = maxHeight !== Infinity && !isNaN(maxHeight) ? maxHeight : 0;

        this.designer.$svg.attr('width', this.width);
        this.designer.$svg.attr('height', this.height);
        this.designer.$svg.attr('viewBox', `0 0 ${this.width} ${this.height}`);

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_RESIZE, {
          width: this.width,
          height: this.height,
        });
        this.updateDataInStore();
      };

      DesignerPackage.prototype.getSize = function () {
        return {
          width: this.width,
          height: this.height,
        };
      };

      DesignerPackage.prototype.getComponentById = function (componentId) {
        return _.find(this.components, function (component) {
          return component.id === componentId;
        });
      };

      DesignerPackage.prototype.importJSON = function () {
        var tempScope = $rootScope.$new();
        var template = "<package-json-import-form ng-model='newPackageJson'></package-json-import-form>";
        tempScope.newPackageJson = '';
        var options = {
          titleText: $translate.instant('package.controller.modals.import_json.actions.title'),
          saveButtonText: $translate.instant('package.controller.modals.import_json.actions.save'),
          hasPadding: false,
          onSave: () => {
            try {
              var json = JSON.parse(tempScope.newPackageJson);
            } catch (e) {
              notify.error(null, $translate.instant('response.422.invalid_json_message'));
              return;
            }
            const { variables, metadata, components, edges } = json;
            const data_flow_json = { components, edges };
            const name = json.metadata && json.metadata.name ? json.metadata.name : 'Untitled package';
            const description = json.metadata && json.metadata.description ? json.metadata.description : '';
            Package.update(
              this.id,
              {
                data_flow_json,
                variables,
                name,
                description,
                metadata,
              },
              { include: 'flow', auto_map_connections: true },
            ).subscribe(function (response) {
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATE_DATA, response);
              notify.success(null, $translate.instant('designer.controls.actions.import_json_package.success'));
            });
            modalService.hideModal();
          },
        };

        modalService.showModal(options, template, tempScope);
      };

      DesignerPackage.prototype.exportJSON = function () {
        let fileName = this.name.toLowerCase().replace(/\s/g, '_');
        Package.export(this.id).subscribe(function (result) {
          downloadObjectAsJson(result, fileName);
        });
      };

      DesignerPackage.prototype.createMajorVersion = function () {
        const _this = this;
        const tempScope = $rootScope.$new();
        const template = "<package-version-message-form ng-model='versionMessage'></package-version-message-form>";
        tempScope.versionMessage = '';
        tempScope.loading = true;
        let modal = null;
        const options = {
          titleText: $translate.instant('package.controller.modals.major_version.actions.title'),
          saveButtonText: $translate.instant('package.controller.modals.major_version.actions.save'),
          hasPadding: false,
          onSave() {
            modal.loading(true);
            const _package = _this.getData();
            _package.version_description = tempScope.versionMessage;
            Package.majorVersion(_this.id, _package).subscribe(function (response) {
              _this.dataChanged = false;
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SAVED);
              $rootScope.$broadcast(DESIGNER_EVENTS.HISTORY_CHANGE, {
                hasUndo: _this.designer.history.hasUndo(),
                hasRedo: _this.designer.history.hasRedo(),
                packageDataChanged: false,
              });
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATE_VERSION, response);
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATED);
              notify.success(
                null,
                $translate.instant('designer.controls.actions.create_major_version.success', {
                  version: response.package_version,
                }),
              );
              modal.loading(false);
              modalService.hideModal();
            });
          },
        };

        modal = modalService.showModal(options, template, tempScope);
      };

      DesignerPackage.prototype.openVersionsModal = function () {
        const _this = this;
        const tempScope = $rootScope.$new();

        tempScope.package = _this.getData();

        $translate([
          'package.generic-list.item.modals.version',
          'package.generic-list.item.modals.run_job.close_to_packages',
        ]).then(function (t) {
          const modalSettings = {
            titleText: t['package.generic-list.item.modals.version'],
            closeButtonText: t['package.generic-list.item.modals.run_job.close_to_packages'],
            hasPadding: false,
            hasFooter: false,
            hasScroll: false,
            onSave() {},
            onClose() {
              modalService.hideModal();
            },
          };

          modalService.showModal(modalSettings, '<package-version-form/>', tempScope);
        });
      };

      DesignerPackage.prototype.selectComponents = function (selectorPosition) {
        let totalSelectedComponents = 0;
        const _this = this;

        _.each(this.components, function (component, index) {
          if (
            selectorPosition.x + selectorPosition.width > component.x &&
            selectorPosition.x < component.x + _this.componentWidth &&
            selectorPosition.y + selectorPosition.height > component.y &&
            selectorPosition.y < component.y + _this.componentHeight
          ) {
            component.setSelection(true);
            totalSelectedComponents++;
          } else {
            component.setSelection(false);
          }
        });

        _.each(this.notes, function (note, index) {
          if (
            selectorPosition.x + selectorPosition.width > note.x &&
            selectorPosition.x < note.x + _this.noteWidth &&
            selectorPosition.y + selectorPosition.height > note.y &&
            selectorPosition.y < note.y + _this.noteHeight
          ) {
            note.setSelection(true);
            totalSelectedComponents++;
          } else {
            note.setSelection(false);
          }
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, totalSelectedComponents);
      };

      DesignerPackage.prototype.duplicateSelectedComponents = function () {
        const _this = this;
        const edgesData = [];
        const duplicatedEdges = [];
        const duplicatedComponents = [];
        const duplicatedNotes = [];
        let totalSelectedComponents = 0;

        _.each(this.edges, function (edge, index) {
          if (edge.sourceComponent.selected && edge.targetComponent.selected) {
            const edgeData = edge.getData();
            delete edgeData.id;
            edgesData.push(edgeData);
          }
        });

        _.each(this.components, function (component, index) {
          if (component.selected) {
            const componentClone = component.clone();
            duplicatedComponents.push(componentClone);
            componentClone.setSelection(true);
            component.setSelection(false);
            _.each(edgesData, function (edgeData) {
              if (edgeData.source === component.id) edgeData.source = componentClone.id;
              if (edgeData.target === component.id) edgeData.target = componentClone.id;
            });
            totalSelectedComponents++;
          }
        });

        _.each(this.notes, function (note, index) {
          if (note.selected) {
            const noteClone = note.clone();
            duplicatedNotes.push(noteClone);
            noteClone.setSelection(true);
            note.setSelection(false);
            totalSelectedComponents++;
          }
        });

        this.components.push.apply(this.components, duplicatedComponents);
        this.notes.push.apply(this.notes, duplicatedNotes);

        _.each(edgesData, function (edgeData) {
          duplicatedEdges.push(new DesignerEdge(edgeData, _this));
        });

        this.edges.push.apply(this.edges, duplicatedEdges);

        $timeout(function () {
          _this.setSize();
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, totalSelectedComponents);
        this.checkEffected();
        this.checkSameName();
        this.designer.history.save('Duplicate of selected components');
        this.updateDataInStore();
      };

      DesignerPackage.prototype.checkSameName = function () {
        const componentNames = [];
        var checkName = function (component) {
          if (componentNames.indexOf(component.name) > -1) {
            component.name = `copy_of_${component.name}`;
            checkName(component);
          } else {
            componentNames.push(component.name);
          }
        };
        _.each(this.components, function (component, index) {
          checkName(component);
        });
      };

      DesignerPackage.prototype.selectConnectedComponents = function () {
        let totalSelectedComponents = 0;

        _.each(this.components, function (component, index) {
          if (component.inputs > 0 || component.outputs > 0) {
            component.setSelection(true);
            totalSelectedComponents++;
          } else {
            component.setSelection(false);
          }
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, totalSelectedComponents);
      };

      DesignerPackage.prototype.selectAllComponents = function () {
        _.each(this.components, function (component, index) {
          component.setSelection(true);
        });
        _.each(this.notes, function (note, index) {
          note.setSelection(true);
        });
        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, this.components.length + this.notes.length);
      };

      DesignerPackage.prototype.unselectAllComponents = function () {
        _.each(this.components, function (component, index) {
          component.setSelection(false);
        });
        _.each(this.notes, function (note, index) {
          note.setSelection(false);
        });
        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, 0);
      };

      DesignerPackage.prototype.deleteSelectedComponents = function () {
        const _this = this;
        const componentsToRemove = _.filter(this.components, { selected: true });
        const notesToRemove = _.filter(this.notes, { selected: true });

        _.each(componentsToRemove, function (component, index) {
          _this.removeComponent(component, true);
        });

        _.each(notesToRemove, function (note, index) {
          _this.removeNote(note, true);
        });

        this.designer.history.save('Delete of multiple components');

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, 0);

        this.update();
        this.checkEffected();
        this.updateDataInStore();
      };

      DesignerPackage.prototype.checkEffected = function () {
        const _this = this;

        $timeout(function () {
          let effected = false;
          _.each(_this.components, function (component, index) {
            if (angular.element(`#${component.id}`).length === 0) effected = true;
          });
          _.each(_this.notes, function (note, index) {
            if (angular.element(`#${note.id}`).length === 0) effected = true;
          });
          if (effected) _this.designer.history.changeData();
        });
      };

      DesignerPackage.prototype.align = function () {
        const graph = new dagre.graphlib.Graph();
        const size = this.cell;
        const _this = this;

        graph.setGraph({
          marginy: size,
          edgesep: size * 3,
          nodesep: size * 3,
          ranksep: size * 3,
        });

        graph.setDefaultEdgeLabel(function () {
          return {};
        });

        _.each(this.components, function (component) {
          graph.setNode(component.id, component);
        });

        _.each(this.notes, function (note) {
          graph.setNode(note.id, note);
        });

        _.each(this.edges, function (edge) {
          graph.setEdge(edge._data.source, edge._data.target);
        });

        dagre.layout(graph);

        const gwidth = graph.graph().width;
        const dwidth = this.width;
        let offsetX = 0;

        if (gwidth < dwidth) {
          offsetX = (dwidth - gwidth) / 2 - this.componentWidth / 2;
          offsetX = offsetX > 0 ? offsetX : 0;
        }

        _.each(this.components, function (component) {
          const node = graph.node(component.id);
          component.setPosition({
            x: _this.snapToGrid(node.x + offsetX),
            y: _this.snapToGrid(node.y),
          });
        });

        _.each(this.notes, function (note) {
          const node = graph.node(note.id);
          note.setPosition({
            x: _this.snapToGrid(node.x + offsetX),
            y: _this.snapToGrid(node.y),
          });
        });

        this.setSize();

        this.designer.history.save('Package aligned');
        this.updateDataInStore();
      };

      DesignerPackage.prototype.removeComponent = function (component, multipleRemove) {
        const sourceEdges = _.filter(this.edges, { source: component.id });
        const targetEdges = _.filter(this.edges, { target: component.id });

        _.each(sourceEdges, function (sourceEdge) {
          sourceEdge.sourceComponent.removeOutput(sourceEdge);
          sourceEdge.targetComponent.removeInput(sourceEdge);
        });

        _.each(targetEdges, function (targetEdge) {
          targetEdge.sourceComponent.removeOutput(targetEdge);
          targetEdge.targetComponent.removeInput(targetEdge);
        });

        _.remove(this.components, {
          id: component.id,
        });

        _.remove(this.edges, {
          source: component.id,
        });
        _.remove(this.edges, {
          target: component.id,
        });

        if (!multipleRemove) {
          this.designer.history.save('Component removed');
          this.update();
        }

        if (component.selected) {
          const totalSelected = _.filter(this.components, { selected: true }).length;
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, totalSelected);
        }

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VARIABLES_REMOVE, `${component.name}_connection`);
        this.updateDataInStore();
      };

      DesignerPackage.prototype.addNote = function (note) {
        note = note || new DesignerNote(null, this);

        this.notes.push(note);

        const _this = this;
        $timeout(function () {
          _this.setSize();
          _this.designer.history.save('Note added');
          _this.update();
        });
      };

      DesignerPackage.prototype.createComponentByType = function (type, component) {
        let newComponent = null;

        switch (type) {
          case COMPONENT_TYPE.CLOUD_STORAGE_SOURCE_COMPONENT:
            newComponent = new DesignerFileStorageSourceComponent();
            break;
          case COMPONENT_TYPE.AMAZON_REDSHIFT_SOURCE_COMPONENT:
            newComponent = new DesignerAmazonRedshiftSourceComponent();
            break;
          case COMPONENT_TYPE.DATABASE_SOURCE_COMPONENT:
            newComponent = new DesignerDatabaseSourceComponent();
            break;
          case COMPONENT_TYPE.BIG_QUERY_SOURCE_COMPONENT:
            newComponent = new DesignerGoogleBigQuerySourceComponent();
            break;
          case COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT:
            if (component.analytics_source_component) {
              component.analytics_source_component.quota_user = this.id;
            } else {
              component.quota_user = this.id;
            }
            newComponent = new DesignerGoogleAnalyticsSourceComponent();
            break;
          case COMPONENT_TYPE.ANALYTICS_GA4_SOURCE_COMPONENT:
            if (component.analytics_ga4_source_component) {
              component.analytics_ga4_source_component.quota_user = this.id;
            } else {
              component.quota_user = this.id;
            }
            newComponent = new DesignerGoogleAnalytics4SourceComponent();
            break;
          case COMPONENT_TYPE.ADWORDS_SOURCE_COMPONENT:
            newComponent = new DesignerGoogleAdwordsSourceComponent();
            break;
          case COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT:
            newComponent = new DesignerFacebookAdsInsightsSourceComponent();
            break;
          case COMPONENT_TYPE.BING_ADS_SOURCE_COMPONENT:
            newComponent = new DesignerBingSourceComponent();
            break;
          case COMPONENT_TYPE.REST_API_SOURCE_COMPONENT:
            newComponent = new DesignerRestApiSourceComponent();
            break;
          case COMPONENT_TYPE.SPANNER_SOURCE_COMPONENT:
            newComponent = new DesignerGoogleSpannerSourceComponent();
            break;
          case COMPONENT_TYPE.MONGO_SOURCE_COMPONENT:
            newComponent = new DesignerMongoDBSourceComponent();
            break;
          case COMPONENT_TYPE.SALESFORCE_SOURCE_COMPONENT:
            newComponent = new DesignerSalesforceSourceComponent();
            break;
          case COMPONENT_TYPE.NET_SUITE_SOURCE_COMPONENT:
            newComponent = new DesignerNetsuiteSourceComponent();
            break;
          case COMPONENT_TYPE.NETSUITE_SOAP_DESTINATION_COMPONENT:
            newComponent = new DesignerNetsuiteDestinationComponent();
            break;
          case COMPONENT_TYPE.TIKTOK_ADS_DESTINATION_COMPONENT:
            newComponent = new DesignerTiktokAdsDestinationComponent();
            break;
          case COMPONENT_TYPE.SELECT_COMPONENT:
            newComponent = new DesignerSelectComponent();
            break;
          case COMPONENT_TYPE.SORT_COMPONENT:
            newComponent = new DesignerSortComponent();
            break;
          case COMPONENT_TYPE.RANK_COMPONENT:
            newComponent = new DesignerRankComponent();
            break;
          case COMPONENT_TYPE.LIMIT_COMPONENT:
            newComponent = new DesignerLimitComponent();
            break;
          case COMPONENT_TYPE.SAMPLE_COMPONENT:
            newComponent = new DesignerSampleComponent();
            break;
          case COMPONENT_TYPE.UNION_COMPONENT:
            newComponent = new DesignerUnionComponent();
            break;
          case COMPONENT_TYPE.AGGREGATE_COMPONENT:
            newComponent = new DesignerAggregateComponent();
            break;
          case COMPONENT_TYPE.JOIN_COMPONENT:
            newComponent = new DesignerJoinComponent();
            break;
          case COMPONENT_TYPE.CROSS_JOIN_COMPONENT:
            newComponent = new DesignerCrossJoinComponent();
            break;
          case COMPONENT_TYPE.WINDOW_COMPONENT:
            newComponent = new DesignerWindowComponent();
            break;
          case COMPONENT_TYPE.CUBE_COMPONENT:
            newComponent = new DesignerCubeComponent();
            break;
          case COMPONENT_TYPE.CLONE_COMPONENT:
            newComponent = new DesignerCloneComponent();
            break;
          case COMPONENT_TYPE.FILTER_COMPONENT:
            newComponent = new DesignerFilterComponent();
            break;
          case COMPONENT_TYPE.ASSERT_COMPONENT:
            newComponent = new DesignerAssertComponent();
            break;
          case COMPONENT_TYPE.CLOUD_STORAGE_DESTINATION_COMPONENT:
            newComponent = new DesignerFileStorageDestinationComponent();
            break;
          case COMPONENT_TYPE.DATABASE_DESTINATION_COMPONENT:
            newComponent = new DesignerDatabaseDestinationComponent();
            break;
          case COMPONENT_TYPE.SPANNER_DESTINATION_COMPONENT:
            newComponent = new DesignerGoogleSpannerDestinationComponent();
            break;
          case COMPONENT_TYPE.AMAZON_REDSHIFT_DESTINATION_COMPONENT:
            newComponent = new DesignerAmazonRedshiftDestinationComponent();
            break;
          case COMPONENT_TYPE.BIG_QUERY_DESTINATION_COMPONENT:
            newComponent = new DesignerGoogleBigqueryDestinationComponent();
            break;
          case COMPONENT_TYPE.MONGO_DESTINATION_COMPONENT:
            newComponent = new DesignerMongoDBDestinationComponent();
            break;
          case COMPONENT_TYPE.SNOWFLAKE_DESTINATION_COMPONENT:
            newComponent = new DesignerSnowflakeDestinationComponent();
            break;
          case COMPONENT_TYPE.SALESFORCE_DESTINATION_COMPONENT:
            newComponent = new DesignerSalesforceDestinationComponent();
            break;
          case COMPONENT_TYPE.FACEBOOK_ADS_DESTINATION_COMPONENT:
            newComponent = new DesignerFacebookDestinationComponent();
            break;
          case COMPONENT_TYPE.SALESFORCE_SOAP_DESTINATION_COMPONENT:
            newComponent = new DesignerSalesforceSoapDestinationComponent();
            break;
          case COMPONENT_TYPE.GOOGLE_ADS_DESTINATION_COMPONENT:
            newComponent = new DesignerGoogleAdsDestinationComponent();
            break;
          case COMPONENT_TYPE.RUN_PACKAGE_COMPONENT:
            newComponent = new DesignerRunPackageComponent();
            break;
          case COMPONENT_TYPE.EXECUTE_SQL_COMPONENT:
            newComponent = new DesignerExecuteSqlComponent();
            break;
          case COMPONENT_TYPE.STICKY_NOTE_COMPONENT:
            newComponent = new DesignerNote(component, this);
            break;
          default:
            newComponent = new DesignerComponent();
            break;
        }

        if (type !== COMPONENT_TYPE.STICKY_NOTE_COMPONENT) {
          newComponent.setPackage(this);
          if (Object.keys(component).length === 1) {
            newComponent.fixAndSetData(component);
          } else {
            newComponent.setData(component);
          }
        }

        return newComponent;
      };

      DesignerPackage.prototype.addComponent = function (component) {
        let sourceComponent;

        if (angular.isDefined(component.sourceComponentId)) {
          sourceComponent = this.getComponentById(component.sourceComponentId);
          if (angular.isDefined(sourceComponent)) {
            component.xy = [sourceComponent.x, sourceComponent.y + sourceComponent.height + sourceComponent.cell * 3];
          }
        }

        var component = this.createComponentByType(component.componentType, component);

        this.components.push(component);

        if (sourceComponent) {
          this.createEdge({
            source: sourceComponent.id,
            target: component.id,
            source_index: this.getEdgeSourceIndex(sourceComponent.id),
          });
        }

        $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_ADDED, component);
        $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_ADDED + component.id, component);

        $timeout(() => {
          this.setSize();
          this.designer.history.save('Component added');
          this.update();
        });

        this.updateDataInStore();
      };

      DesignerPackage.prototype.edgeCanBeConnected = function (data) {
        const _this = this;
        let edgeCanBeConnected = true;

        if (data.source === data.target) {
          edgeCanBeConnected = false;
        }

        const getSourceComponentSourcesIds = function (sourceId) {
          const componentSourcesIds = [];
          const sourceComponent = _this.getComponentById(sourceId);
          if (sourceComponent) {
            _.each(sourceComponent.inputEdges, function (edge) {
              componentSourcesIds.push(edge.source);
            });
          }
          return componentSourcesIds;
        };

        var checkLoopingConnection = function (sourceId) {
          const sourceIds = getSourceComponentSourcesIds(sourceId);
          if (sourceIds.length > 0) {
            _.each(sourceIds, function (sourceId) {
              if (sourceId === data.target) {
                edgeCanBeConnected = false;
              }
              checkLoopingConnection(sourceId);
            });
          }
        };

        _.each(this.edges, function (edge) {
          if (edge.source === data.source && edge.target === data.target) {
            edgeCanBeConnected = false;
          }
        });

        checkLoopingConnection(data.source);

        return edgeCanBeConnected;
      };

      DesignerPackage.prototype.getEdgeOrder = function (targetComponentId) {
        let order = 0;
        // var maxOrder = 0;
        const targetComponent = this.getComponentById(targetComponentId);

        if (targetComponent && targetComponent.inputEdges.length > 0) {
          // maxOrder = _.max(targetComponent.inputEdges).order;
          let orderFound = false;
          let i = 0;
          while (!orderFound) {
            const edge = _.find(targetComponent.inputEdges, { order: i });
            if (!edge) {
              orderFound = true;
              order = i;
            } else {
              i++;
            }
          }
        }

        return order;
      };

      DesignerPackage.prototype.getEdgeSourceIndex = function (sourceComponentId) {
        let sourceIndex = 0;
        const sourceComponent = this.getComponentById(sourceComponentId);

        if (sourceComponent && sourceComponent.outputEdges.length > 0) {
          let indexFound = false;
          let i = 0;
          while (!indexFound) {
            const edge = _.find(sourceComponent.outputEdges, { source_index: i });
            if (!edge) {
              indexFound = true;
              sourceIndex = i;
            } else {
              i++;
            }
          }
        }

        return sourceIndex;
      };

      DesignerPackage.prototype.createEdge = function (data) {
        if (!this.edgeCanBeConnected(data)) return;

        console.log(data);

        const edge = new DesignerEdge(data, this);

        this.edges.push(edge);

        this.update();

        $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_ADD, edge);
        $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_ADD + edge.id, edge);

        this.updateDataInStore();
        return edge;
      };

      DesignerPackage.prototype.removeEdge = function (edge) {
        edge.sourceComponent.removeOutput(edge);
        edge.targetComponent.removeInput(edge);

        _.remove(this.edges, {
          id: edge.id,
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_REMOVE, edge);
        $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_REMOVE + edge.id, edge);

        this.designer.history.save('Edge deleted');

        this.update();
      };

      DesignerPackage.prototype.removeNote = function (note, multipleRemove) {
        _.remove(this.notes, {
          id: note.id,
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.NOTE_REMOVE, note);
        $rootScope.$broadcast(DESIGNER_EVENTS.NOTE_REMOVE + note.id, note);

        if (!multipleRemove) {
          this.designer.history.save('Note deleted');
          this.update();
        }
      };

      DesignerPackage.prototype.duplicateComponent = function (component) {
        const clone = component.clone();
        this.components.push(clone);

        this.designer.history.save('Component duplicated');

        this.update();
      };

      DesignerPackage.prototype.copySelectedComponents = function () {
        const componentsIds = [];
        const componentsData = [];
        const notesData = [];
        const edgesData = [];

        const selectedComponents = _.filter(this.components, { selected: true });
        const selectedNotes = _.filter(this.notes, { selected: true });

        _.each(selectedComponents, function (selectedComponent) {
          const componentData = selectedComponent.getFormData();
          componentData.inputMin = selectedComponent.inputMin;
          componentData.inputMax = selectedComponent.inputMax;
          componentData.outputMin = selectedComponent.outputMin;
          componentData.outputMax = selectedComponent.outputMax;
          componentsData.push(componentData);
          componentsIds.push(selectedComponent.id);
        });

        _.each(selectedNotes, function (selectedNote) {
          const noteData = selectedNote.getData();
          noteData.componentType = selectedNote.componentType;
          notesData.push(noteData);
        });

        _.each(this.edges, function (edge) {
          if (componentsIds.indexOf(edge.source) > -1 && componentsIds.indexOf(edge.target) > -1) {
            edgesData.push(edge.getData());
          }
        });

        window.localStorage.setItem('componentsData', JSON.stringify(componentsData));
        window.localStorage.setItem('notesData', JSON.stringify(notesData));
        window.localStorage.setItem('edgesData', JSON.stringify(edgesData));
      };

      DesignerPackage.prototype.pasteSelectedComponents = function () {
        const _this = this;
        const idsMap = {};
        const componentsData = JSON.parse(window.localStorage.getItem('componentsData'));
        const notesData = JSON.parse(window.localStorage.getItem('notesData'));
        const edgesData = JSON.parse(window.localStorage.getItem('edgesData'));

        this.unselectAllComponents();

        _.each(componentsData, function (componentData) {
          const newComponent = _this.createComponentByType(componentData.componentType, componentData);
          const newId = newComponent.getId();
          idsMap[newComponent.id] = newId;
          newComponent.id = newId;
          newComponent.setSelection(true);
          _this.components.push(newComponent);
          _this.checkComponentPosition(newComponent);
        });

        _.each(notesData, function (noteData) {
          const newNote = _this.createComponentByType(noteData.componentType, noteData);
          newNote.id = newNote.getId();
          newNote.setSelection(true);
          _this.notes.push(newNote);
          _this.checkComponentPosition(newNote);
        });

        _.each(edgesData, function (edgeData) {
          _this.createEdge({ source: idsMap[edgeData.source], target: idsMap[edgeData.target] });
        });

        this.checkEffected();
        this.checkSameName();

        _.each(this.components, function (component) {
          component.setShortName();
        });

        this.designer.history.save('Copy of components');
        this.update();
      };

      DesignerPackage.prototype.update = function () {
        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_DISABLED, this.components.length === 0);
        $timeout(function () {
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATED);
        });
        this.updateDataInStore();
      };

      DesignerPackage.prototype.validateComponents = function () {
        let valid = true;
        _.each(this.components, function (component, index) {
          if (!component.valid()) valid = false;
        });
        this.valid = valid;
        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_RUN_JOB_DISABLE, valid);
      };

      DesignerPackage.prototype.setComponentName = function (component, data) {
        if (component instanceof DesignerComponent) {
          let { name } = data;

          if (name === undefined) {
            const _this = this;

            (function getNextName() {
              name = `${_this.toComponentName(data.originalName)}_${++_this._componentsCounter}`;

              const component = _.find(_this.components, function (component) {
                return component.name === name;
              });

              if (component) getNextName();
            })();
          }

          if (name.indexOf(' ') > -1) {
            name = `${this.toComponentName(name)}_${++this._componentsCounter}`;
          }

          component.name = name;
        }
      };

      DesignerPackage.prototype.componentNameExist = function (componentName) {
        const component = _.find(this.components, function (component) {
          return component.name === componentName;
        });

        return angular.isDefined(component);
      };

      DesignerPackage.prototype.checkComponentPosition = function (component) {
        const _this = this;
        const currentPosition = {};
        currentPosition.x = component.x;
        currentPosition.y = component.y;

        (function checkPosition(_position) {
          const samePositionComponent = _.find(_this.components, function (_component) {
            return _component.x === _position.x && _component.y === _position.y && _component.id !== component.id;
          });
          const samePositionNote = _.find(_this.notes, function (note) {
            return note.x === _position.x && note.y === _position.y && note.id !== component.id;
          });
          if (angular.isDefined(samePositionComponent) || angular.isDefined(samePositionNote)) {
            _position.x += _this.cell;
            _position.y += _this.cell;
            checkPosition(_position);
          } else {
            component.x = _position.x;
            component.y = _position.y;
          }
        })(currentPosition);
      };

      DesignerPackage.prototype.prepareData = function () {
        const fileStorageDestinationComponents = _.filter(this.components, {
          componentType: COMPONENT_TYPE.CLOUD_STORAGE_DESTINATION_COMPONENT,
        });

        _.each(fileStorageDestinationComponents, function (fileStorageDestinationComponent) {
          fileStorageDestinationComponent.setParentSchema();
        });
      };

      DesignerPackage.prototype.updateDataInStore = function () {
        const packageItem = {
          components: this.components.map((component) => ({
            [component.componentType]: modifyComponentBeforeSave(component.getData(), component.componentType),
          })),
          created_at: this.created_at,
          description: this.description,
          edges: this.edges.map((edge) => edge.getData()),
          flow_type: this.flow_type,
          flow_version: this.flow_version,
          name: this.name,
          owner_id: this.owner_id,
          package_version: this.package_version,
          status: this.status,
          updated_at: this.updated_at,
          variables: this.variables,
          version_description: this.version_description,
          id: this.id,
        };
        ngrxStoreService.dispatch(updatePackage({ packageItem }));
      };

      return DesignerPackage;
    },
  ]);
})(window.angular);
